import { useIntl } from "react-intl";

import {
  DrawerContent,
  DrawerTopBar,
  SwipeableDrawer,
} from "@/components/Drawer";
import type { HotelsSortValue } from "@/features/hotels/types/types";

import HotelsListsSort from "./HotelsListSort";

type Props = {
  open: boolean;
  value: HotelsSortValue;
  onSubmit: (newValue: HotelsSortValue) => void;
  onClose: () => void;
};

export const HotelsSortDrawer = ({ open, value, onSubmit, onClose }: Props) => {
  const intl = useIntl();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <DrawerTopBar
        onCloseClick={onClose}
        title={intl.formatMessage({
          defaultMessage: "Sorting",
          description: "Label for the sort options in the hotel filters panel",
        })}
      />

      <DrawerContent>
        <HotelsListsSort value={value} onChange={onSubmit} />
      </DrawerContent>
    </SwipeableDrawer>
  );
};
